import { Component, OnInit, Input, Output, EventEmitter, ViewChild, Directive } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PlatformApiService, ResultFilter, Results } from '../services/platform-api.service';
import { merge, of as observableOf, Observable } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { GridSpinnerComponent } from '../shared/grid-spinner.component';

@Directive()
export abstract class GridListComponent<T> {
  state = 'LIST';

  @Output() stateChange: EventEmitter<any> = new EventEmitter();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('spinner', { static: true }) spinner: GridSpinnerComponent;

  get columnsToDisplay() { return []; }
  get Title() { return 'Title'; }

  items: T[];
  selectedItem: T;
  resultsLength: number;
  pageSize = 50;
  isLoading = true;
  pageNumbers: number[];
  goTo: number;
  pageIndex: number;
  @Output() page = new EventEmitter<PageEvent>();

  @Input('pageSize') set pageSizeChanged(ps:number) {
    this.pageSize = ps;
    this.updateGoto();
  }
  @Input('pageIndex') set pageIndexChanged(pageIndex: number) {
    this.pageIndex = pageIndex;
  };

  constructor() { }


  refresh() {
    this.loadItems();
  }
  loadItems() {
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoading = true;
          this.spinner.showSpinner();
          return this.getItems(
            new ResultFilter(
              this.sort.active || 'name',
              this.sort.direction || 'asc',
              this.paginator.pageSize || this.pageSize,
              this.paginator.pageIndex * (this.paginator.pageSize || this.pageSize)));
        }),
        map(data => {
          this.isLoading = false;
          this.spinner.hideSpinner();
          this.resultsLength = data.count;
          this.updateGoto();
          return data.results;
        }),
        catchError(() => {
          this.isLoading = false;
          this.spinner.hideSpinner();
          return observableOf([]);
        })
    ).subscribe(data => {
      this.items = data;
      this.onAfterLoad(data);
    });
  }
  abstract getItems(filter: ResultFilter): Observable<Results>;
  onAfterLoad(data: any[]) {

  }

  updateGoto() {
    this.goTo = (this.pageIndex || 0) + 1;
    this.pageNumbers = [];
    for (let i = 0; i < this.resultsLength / this.pageSize; i++) {
      const a = i+1
      this.pageNumbers.push(a);
    }
  }

  goToPage() {
    this.paginator.pageIndex = this.goTo - 1;
    this.paginator.page.next({
      length: this.paginator.length,
      pageIndex: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize
    });
  }

  paginationChange(pageEvt: PageEvent) {
    this.resultsLength = pageEvt.length;
    this.pageIndex = pageEvt.pageIndex;
    this.pageSize = pageEvt.pageSize;
    this.updateGoto();
  }

  createItem() {
    this.stateChange.emit({ state: 'CREATE' });
  }

  selectItem(event, selectedItem: T) {
    event.stopPropagation();
    if ((selectedItem as any).isActive) {
      this.stateChange.emit({ state: 'SELECT', item: selectedItem });
    }
  }

  editItem(event: Event, selectedItem: T) {
    event.stopPropagation();
    this.stateChange.emit({ state: 'EDIT', item: selectedItem });
  }

  deleteItem(event: Event, selectedItem: T) {
    event.stopPropagation();
    this.stateChange.emit({ state: 'DELETE', item: selectedItem });
  }
}
